import styles from './Header.less';
import React, { Component, PropTypes } from 'react';
import ScreenReaderSkipLink from 'Accessibility/ScreenReaderSkipLink';
import PartnerSites from 'PartnerSites/PartnerSites';
import Locales from 'Locales/Locales';
import Navigation from 'Navigation/Navigation';
import SignInRegister from 'SignInRegister/SignInRegister';
import UserAccount from 'UserAccount/UserAccount';
import ExternalLink from 'ExternalLink/ExternalLink';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

class Header extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired,
    userAuthenticated: PropTypes.bool.isRequired,
    userDisplayName: PropTypes.string.isRequired,
    userReady: PropTypes.bool.isRequired
  };

  render() {
    const { locale, userAuthenticated, userDisplayName, userReady } = this.props;
    const employerLinkHref = locale === 'NZ' ? 'https://talent.seek.co.nz/' : 'https://talent.seek.com.au/';

    return (
      <header role="banner">
        <section className={styles.root}>
          <ScreenReaderSkipLink to="start-of-content">Skip to content</ScreenReaderSkipLink>
          <div className={styles.banner}>
            <h1 data-automation="logo" className={styles.logo}>
              <QualifiedLink analytics="header:jobs" className={styles.logoLink} path="/">SEEK</QualifiedLink>
            </h1>
            <div className={styles.user}>
              {
                userAuthenticated ?
                  <UserAccount {...{ userDisplayName, userReady }} /> :
                  <SignInRegister />
              }
              <div className={styles.employerSite}>
                <span className={styles.divider} />
                <ExternalLink analytics="header:employer+site" className={styles.employerLink} href={employerLinkHref}>Employer site</ExternalLink>
              </div>
            </div>
          </div>
          <div className={styles.navigation}>
            <Navigation locale={locale} />
          </div>
          <div className={styles.topBanner}>
            <div className={styles.topBannerContent}>
              <PartnerSites locale={locale} />
              <div className={styles.locale}>
                <Locales locale={locale} />
              </div>
            </div>
          </div>
        </section>
      </header>
    );
  }

}

export default Header;



/** WEBPACK FOOTER **
 ** ./app/components/Header/Header.js
 **/